import { BaseMeasures } from './BaseMeasures.ts';
class SSRMeasure extends BaseMeasures {
	private startTimeOffset: number = 0;
	private startTime: number = 0;
	// fetch count (counts batched operations as one fetch)
	private fetchCount: number = 0;
	// total operations (counts individual operations even in batched operations)
	private operationsCount: number = 0;
	private errorCount: number = 0;
	private isBifrost: boolean = false;

	public fetchCountIncr() {
		this.fetchCount++;
	}

	public getFetchCount() {
		return this.fetchCount;
	}

	public errorCountIncr() {
		this.errorCount++;
	}

	public getErrorCount() {
		return this.errorCount;
	}

	public operationsCountIncr() {
		this.operationsCount++;
	}

	public getOperationsCount() {
		return this.operationsCount;
	}

	public setIsBifrost(isBifrost: boolean) {
		this.isBifrost = isBifrost;
	}

	public getIsBifrost(): boolean {
		return this.isBifrost;
	}

	/**
	 * Transform a measure name (e.g., replace 'ssr-app' with 'bifrost-ssr')
	 * Override this function to customize measure names
	 */
	public transformMeasureName(name: string): string {
		if (this.getIsBifrost() && name.includes('ssr-app/')) {
			name = name.replace('ssr-app', 'bifrost-ssr/tesseract');

			if (window.__SSR_REACT_STREAMING__ && name.includes('/render/')) {
				name = name.replace('render', 'stream/render');
			}
		}
		return name;
	}

	public setStartTime(startTimeOffset: number = 0): void {
		this.startTimeOffset = startTimeOffset;
		if (!this.startTime) {
			this.startTime = Math.floor(performance.now());
		}
	}

	public getStartTime() {
		return this.startTime;
	}

	public nowFromStartTime() {
		return Math.floor(performance.now()) - this.startTime;
	}

	private now() {
		return this.nowFromStartTime() + this.startTimeOffset;
	}

	public setMeasureDuration(name: string, duration: number) {
		const transformedName = this.transformMeasureName(name);
		const entry = this.measures[transformedName];
		if (entry) {
			entry.duration = duration;
		}
	}

	public addMeasure(name: string, duration: number, offsetStartByDuration = false) {
		const transformedName = this.transformMeasureName(name);
		if (this.measures[transformedName]) {
			return;
		}
		this.measures[transformedName] = {
			startTime: offsetStartByDuration ? this.now() - duration : this.now(),
			duration,
		};
	}

	override markMeasureStart(name: string) {
		const transformedName = this.transformMeasureName(name);
		if (!this.measures[transformedName]) {
			this.measures[transformedName] = {
				startTime: this.now(),
				duration: 0,
			};
		}
	}

	override markMeasureEnd(name: string) {
		const transformedName = this.transformMeasureName(name);
		const entry = this.measures[transformedName];
		if (entry) {
			entry.duration = this.now() - entry.startTime;
		}
	}

	override clearMeasures(): void {
		this.isBifrost = false;
		this.startTimeOffset = 0;
		this.startTime = 0;
		this.fetchCount = 0;
		this.errorCount = 0;
		this.operationsCount = 0;
		this.measures = {};
	}
}

export const SSRMeasures = new SSRMeasure();
